import { useMemo } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import { queryFnFetchErrorWrapper } from 'src/api/utils/errorHandlers';
import { useAccessToken } from 'src/hooks/useAccessToken';
import { FetchError } from 'src/types/TApiQueries';
import { UploadLink } from 'src/types/TUploadLink';
import { getUploadLink } from '../functions/uploadLinksApi';
import { queryNames } from '../utils/queryNames';

/**
 * The upload link with its assets and their upload status. The page passes
 * `refetchInterval` while files are still processing.
 */
export function useUploadLinkQuery(linkId: string, queryOptions?: UseQueryOptions<UploadLink, FetchError>) {
  const accessToken = useAccessToken();

  const queryFn = useMemo(
    () => queryFnFetchErrorWrapper(() => getUploadLink(linkId, accessToken)),
    [linkId, accessToken],
  );

  return useQuery<UploadLink, FetchError>([queryNames.uploadLink, linkId], queryFn as any, {
    // 404 (not found, or another user's link) is an answer, not a blip
    retry: false,
    ...queryOptions,
  });
}
